export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Attachment-Gray-254a6c44cf14e2a8066ec27edb4d3a0b.svg";